// Publish now → Needs to have for each platform either text or image and text length within limits

import { postExcededTextLimit } from '../utils/postHelpers';
import { rrulestr } from 'rrule';
import {
  BTN_PUBLISH_AND_CONFIGURE,
  BTN_SAVE_AS_DRAFT,
  MAX_INSTAGRAM_HASHTAGS,
  MEDIA_TYPE_DOC
} from './constants';
import {
  ALL,
  FACEBOOK,
  INSTAGRAM,
  LINKEDIN_BUSINESS_PAGE,
  LINKEDIN_PERSONAL_ACCOUNT,
  PINTEREST,
  PLATFORM_LIST_WITH_ALL,
  YOUTUBE
} from '../../../config/constants';
import {
  POST_TYPE_PRODUCT,
  POST_TYPE_REEL_KEY,
  POST_TYPE_STORY_KEY,
  POST_TYPE_TO_PREFIX
} from './platformFeatures';
import {
  countAllCharacters,
  HASHTAG_REGEX
} from '../components/creatorTextEditor/config';
import { add } from 'lodash';
import { co } from '@fullcalendar/core/internal-common';
import {
  STEP_MODE_MULTI_STEP,
  STEP_MODE_SINGLE_STEP,
  TARGET_PUBLISH_WITH_SCHEDULE,
  TARGET_SAVE_AS_APPROVED_POST
} from '../../../redux/slices/LomavisPostApproval/constants';
import { isValidURL } from '../../whatsappTemplateBuilder/helpers';
export const TextLengthValid = (lomavisCreator: any) => {
  // checks if the text length is within the limits for each platform
  const { platformEnabled, postTypeSelected, quillEditors } = lomavisCreator;

  const results = Object.keys(platformEnabled)
    .filter((platform) => platformEnabled[platform])
    .map((platform) => {
      const postData = lomavisCreator.postData[platform];
      if (!postData) return { isValid: true, platform };
      // check if post exceeds the limit

      const { text_length } = postData;
      const isValid = !postExcededTextLimit(
        platform,
        postTypeSelected[platform],
        text_length
      );
      return { isValid, platform };
    });
  return removeDuplicates(results);
};
export const PostHasTextOrMedia = (lomavisCreator: any) => {
  // checks if the post has text or media for each platform
  const { platformEnabled, postData } = lomavisCreator;
  const results = Object.keys(platformEnabled)
    .filter((platform) => platformEnabled[platform])
    .map((platform) => {
      const post = postData[platform];
      if (!post) return { isValid: true, platform };
      if (
        post.text_length_striped == 0 &&
        (!post?.media || post?.media?.length == 0)
      )
        return { isValid: false, platform };
      return { isValid: true, platform };
    });
  return removeDuplicates(results);
};

export const postHasPublicationDate = (lomavisCreator: any) => {
  // checks if the post has a publication date for each platform
  const { platformEnabled, postData, is_recurring_post, recurrence_as_str } =
    lomavisCreator;
  const resuls = Object.keys(platformEnabled)
    .filter((platform) => platformEnabled[platform])
    .map((platform) => {
      const post = postData[platform];
      if (!post) return { isValid: true, platform };
      if (is_recurring_post) {
        const rruleObj = rrulestr(recurrence_as_str);
        if (!rruleObj) return { isValid: false, platform };
        if (!rruleObj?.options?.dtstart || !rruleObj?.options?.until)
          return { isValid: false, platform };
        // use rrule  lib to check if there is a publication date TODO
        return { isValid: true, platform };
      } else {
        // use Date to parse the date if it is a valid date
        if (!post.planned_publication_datetime)
          return { isValid: false, platform };
        const date = new Date(post.planned_publication_datetime);
        if (isNaN(date.getTime())) {
          return { isValid: false, platform };
        }
      }
      return { isValid: true, platform };
    });
  return removeDuplicates(resuls);
};

export const showButton = (lomavisCreator: any, button: any) => {
  const show = Boolean(
    (button.showOnCloud && lomavisCreator.lomavisCreatorConfig.cloud) ||
      (button.showOnMultipost &&
        lomavisCreator.lomavisCreatorConfig.is_multipost) ||
      (button.showOnCockpit && lomavisCreator.lomavisCreatorConfig.location)
  );
  if (!show) return false;
  const postNotPlanned = postHasPublicationDate(lomavisCreator)
    .map((item) => item.isValid)
    .includes(false);
  if (button.showOnPlanningOnly && postNotPlanned) return false;
  if (button.key === BTN_PUBLISH_AND_CONFIGURE && !postNotPlanned) return false;

  return true;
};

export const mediaIsLoading = (lomavisCreatorState: any) => {
  // Returns true if at least one platform has content that is loading, false otherwise
  const { postData, platformEnabled } = lomavisCreatorState;
  const results = Object.keys(platformEnabled)
    .filter((platform) => platformEnabled[platform])
    .concat(ALL)
    .map((platform) => {
      const post = postData[platform];

      if (!post) return { isValid: true, platform };
      if (post.media?.filter((file) => !file?.uploaded).length > 0)
        return { isValid: false, platform };
      return { isValid: true, platform };
    });
  return removeDuplicates(results);
};

export const validateYoutubeTitleLength = (lomavisCreator: any) => {
  // checks if the youtube title length is within the limits
  const { platformEnabled, postData } = lomavisCreator;
  if (!platformEnabled[YOUTUBE]) return [{ isValid: true, platform: YOUTUBE }];
  const youtubePost = postData[YOUTUBE];
  if (!youtubePost) return [{ isValid: true, platform: YOUTUBE }];
  const { youtube_title } = youtubePost;
  if (youtube_title?.length > 100)
    return [{ isValid: false, platform: YOUTUBE }];
  return [{ isValid: true, platform: YOUTUBE }];
};

export const validateYoutubeTitleExists = (lomavisCreator: any) => {
  // checks if the youtube title exists
  const { platformEnabled, postData } = lomavisCreator;
  if (!platformEnabled[YOUTUBE]) return [{ isValid: true, platform: YOUTUBE }];
  const youtubePost = postData[YOUTUBE];
  if (!youtubePost) return [{ isValid: true, platform: YOUTUBE }];
  const { youtube_title } = youtubePost;
  if (!youtube_title) return [{ isValid: false, platform: YOUTUBE }];
  return [{ isValid: true, platform: YOUTUBE }];
};
export const oneMediaShouldBeSelected = (lomavisCreator: any) => {
  // ig/fb story/reel: At least one media file needs to be available.
  // YouTube: At least one media file needs to be available
  const { platformEnabled, postData, postTypeSelected } = lomavisCreator;

  const results = Object.keys(platformEnabled)
    .filter((platform) => platformEnabled[platform]) // Only check enabled platforms
    .map((platform) => {
      const post = postData[platform];
      if (!post) return { isValid: true, platform }; // If no post data, it's valid by default

      // Validate for YouTube
      if (platform === YOUTUBE) {
        if (!post.media || post.media.length === 0) {
          return { isValid: false, platform };
        }
      }

      // Validate for Facebook
      if (
        platform === FACEBOOK &&
        (postTypeSelected[FACEBOOK] === POST_TYPE_STORY_KEY ||
          postTypeSelected[FACEBOOK] === POST_TYPE_REEL_KEY)
      ) {
        if (!post.media || post.media.length === 0) {
          return { isValid: false, platform };
        }
      }
      // validate for instagram:
      if (platform === INSTAGRAM) {
        if (!post.media || post.media.length === 0) {
          return { isValid: false, platform };
        }
      }
      if (platform === PINTEREST) {
        if (!post.media || post.media.length === 0) {
          return { isValid: false, platform };
        }
      }

      // If none of the conditions matched, it's valid
      return { isValid: true, platform };
    });
  return removeDuplicates(results);
};
const generalLinksKeys = ['link1', 'link2', 'link3'];
const generalOptionsUrlsKeys = ['more_information_link', ...generalLinksKeys];
export const textIsUrl = (text) => {
  const urlRegex =
    /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/;
  return urlRegex.test(text);
};
export const isStrictURL = (str: string): boolean => {
  const pattern = /^(https?):\/\/([\w.-]+)(:\d+)?(\/\S*)?$/i;
  return pattern.test(str);
};
export const isGeneralLinksHasTitles = (lomavisCreator: any) => {
  const postType = lomavisCreator.general_post_type;
  const prefix = POST_TYPE_TO_PREFIX[postType];
  const results = [];
  PLATFORM_LIST_WITH_ALL.map((platform) => {
    // check only active platforms
    if (!lomavisCreator.platformEnabled[platform])
      return { isValid: true, platform };
    const post = lomavisCreator.postData[platform];
    if (!post) return { isValid: true, platform };
    const r = generalLinksKeys.map((key) => {
      const postKey = `${prefix}_${key}`;
      if (!post[postKey] && !post[`${postKey}_title`])
        return { isValid: true, platform };
      // check if they are empty current trimming
      if (!post[postKey]?.trim() && !post[`${postKey}_title`]?.trim())
        return { isValid: true, platform };
      if (!post[postKey] && post[`${postKey}_title`])
        return { isValid: false, platform };
      if (!post[`${postKey}_title`] && post[postKey])
        return { isValid: false, platform };
      return { isValid: true, platform };
    });
    results.push(...r);
  });
  return removeDuplicates(results);
};
export const isGeneralOptionsUrlsValid = (lomavisCreator: any) => {
  const postType = lomavisCreator.general_post_type;
  const prefix = POST_TYPE_TO_PREFIX[postType];
  const results = [];
  PLATFORM_LIST_WITH_ALL.map((platform) => {
    const post = lomavisCreator.postData[platform];
    // check only active platforms
    if (!lomavisCreator.platformEnabled[platform])
      return { isValid: true, platform };
    if (!post) return { isValid: true, platform };
    const r = generalOptionsUrlsKeys.map((key) => {
      const postKey = `${prefix}_${key}`;
      if (!post[postKey] || !post[postKey].trim())
        return { isValid: true, platform };
      // check if its a valid url using regex
      if (!textIsUrl(post[postKey])) {
        return { isValid: false, platform };
      }
      return { isValid: true, platform };
    });
    results.push(...r);
  });
  return removeDuplicates(results);
};
export const generalTitleIsRequired = (lomavisCreator: any) => {
  const postType = lomavisCreator.general_post_type;
  const prefix = POST_TYPE_TO_PREFIX[postType];
  if (!prefix) return [{ isValid: true, platform: ALL }];
  const results = [];
  PLATFORM_LIST_WITH_ALL.map((platform) => {
    if (!lomavisCreator.platformEnabled[platform])
      return { isValid: true, platform };
    const post = lomavisCreator.postData[platform];
    if (!post) return { isValid: true, platform };
    const r = ['title'].map((key) => {
      const postKey = `${prefix}_${key}`;
      if (!post[postKey]) return { isValid: false, platform };
      if (!post[postKey].trim()) return { isValid: false, platform };
      return { isValid: true, platform };
    });
    results.push(...r);
  });
  return removeDuplicates(results);
};

export const removeDuplicates = (results) => {
  const uniqueResults = new Map();

  results.forEach((result) => {
    const { platform, isValid } = result;

    // If platform doesn't exist or current isValid is false, update the map
    if (!uniqueResults.has(platform) || isValid === false) {
      uniqueResults.set(platform, result);
    }
  });

  // Convert the map back to an array
  return Array.from(uniqueResults.values());
};

export const validateLinkedinDocumentTitleExists = (lomavisCreator: any) => {
  const { postData, platformEnabled } = lomavisCreator;
  const activePlatformsList = [];
  // check both linkedin and linkedin_business_page if they active add them to platformsList
  if (platformEnabled[LINKEDIN_BUSINESS_PAGE])
    activePlatformsList.push(LINKEDIN_BUSINESS_PAGE);
  if (platformEnabled[LINKEDIN_PERSONAL_ACCOUNT])
    activePlatformsList.push(LINKEDIN_PERSONAL_ACCOUNT);
  const results = activePlatformsList.map((platform) => {
    const post = postData[platform];
    if (!post) return { isValid: true, platform };
    // check if post has a media file type doc
    const hasDocument = post.media?.find(
      (m) => m.media_type === MEDIA_TYPE_DOC
    );
    if (!hasDocument) return { isValid: true, platform };
    if (!post?.linkedin_document_title?.trim())
      return { isValid: false, platform };
    return { isValid: true, platform };
  });
  return removeDuplicates(results);
};

export const validateDateIsInFuture = (lomavisCreator: any) => {
  const { postData, platformEnabled } = lomavisCreator;
  const results = Object.keys(platformEnabled)
    .filter((platform) => platformEnabled[platform])
    .map((platform) => {
      const post = postData[platform];
      if (!post) return { isValid: true, platform };
      // if no publication date return true
      if (!post.planned_publication_datetime)
        return { isValid: true, platform };
      const date = new Date(post.planned_publication_datetime);
      if (date.getTime() < Date.now()) return { isValid: false, platform };
      return { isValid: true, platform };
    });
  return removeDuplicates(results);
};

export const instagramShouldHaveLessThan20Hashtags = (lomavisCreator: any) => {
  const { postData, platformEnabled } = lomavisCreator;
  // if INSTAGRAM is not enabled return true
  if (!platformEnabled[INSTAGRAM])
    return [{ isValid: true, platform: INSTAGRAM }];
  if (!postData[INSTAGRAM]) return [{ isValid: true, platform: INSTAGRAM }];
  const post = postData[INSTAGRAM];
  const { text_as_text } = post;
  const hashtags = text_as_text?.match(HASHTAG_REGEX) || [];
  if (hashtags.length > MAX_INSTAGRAM_HASHTAGS)
    return [{ isValid: false, platform: INSTAGRAM }];
  return [{ isValid: true, platform: INSTAGRAM }];
};

export const pinterestShouldHaveBoardSelected = (lomavisCreator: any) => {
  const {
    postData: {
      [PINTEREST]: { additional_publication_data }
    },
    platformEnabled
  } = lomavisCreator;

  if (!platformEnabled[PINTEREST])
    return [{ isValid: true, platform: PINTEREST }];
  if (lomavisCreator.lomavisCreatorConfig.cloud) {
    return [{ isValid: true, platform: PINTEREST }];
  }
  if (!additional_publication_data)
    return [{ isValid: false, platform: PINTEREST }];
  if (!additional_publication_data.board)
    return [{ isValid: false, platform: PINTEREST }];
  return [{ isValid: true, platform: PINTEREST }];
};

export const pinterestShouldHaveValidLinks = (lomavisCreator: any) => {
  const {
    postData: {
      [PINTEREST]: { additional_publication_data }
    },
    platformEnabled
  } = lomavisCreator;

  // If Pinterest isn't enabled, always valid by default
  if (!platformEnabled[PINTEREST]) {
    return [{ isValid: true, platform: PINTEREST }];
  }

  // Safely destructure links (default to empty array if undefined)
  const { links = [] } = additional_publication_data || {};

  // valdiate single link field
  const link = additional_publication_data?.link;
  if (link && !textIsUrl(link)) {
    return [{ isValid: false, platform: PINTEREST }];
  }
  // Check each link
  for (const linkObject of links) {
    // Ignore empty strings
    const linkValue = linkObject.link;
    console.log('link', linkValue);
    if (linkValue === '') {
      continue;
    }
    // If any link is invalid, return immediately
    if (!textIsUrl(linkValue)) {
      console.log('link', linkValue);
      return [{ isValid: false, platform: PINTEREST }];
    }
  }

  // If we get here, all links are valid
  return [{ isValid: true, platform: PINTEREST }];
};

export const locationShouldBeSelectedMultiPost = (lomavisCreator: any) => {
  if (!lomavisCreator.lomavisCreatorConfig?.is_multipost) {
    // If not a multipost, return true for all platforms
    return [{ isValid: true, platform: ALL }];
  }
  // check if post is multi post and no locations are selected return false

  const noSelectedLocations =
    Object.keys(lomavisCreator?.tempState?.creator_multipost_config ?? {})
      .length === 0;

  // check if this is an update post
  const isUpdatePost = lomavisCreator?.lomavisCreatorConfig?.is_update;
  const postIsMultipost = lomavisCreator?.lomavisCreatorConfig?.is_multipost;
  if (postIsMultipost && noSelectedLocations)
    return [{ isValid: false, platform: ALL }];
  return [{ isValid: true, platform: ALL }];
};

export const lomavisPostApprovalExist = (lomavisCreator: any) => {
  const { approval_process } = lomavisCreator;

  if (!approval_process) {
    return [{ isValid: false, platform: ALL }];
  }

  return [{ isValid: true, platform: ALL }];
};

export const lomavisPostApprovalSingleStep = (lomavisCreator: any) => {
  const { approval_process } = lomavisCreator;

  if (
    approval_process &&
    approval_process?.step_mode === STEP_MODE_SINGLE_STEP
  ) {
    if (
      approval_process?.approval_step_1_users?.length === 0 &&
      !approval_process?.approval_step_1_group
    ) {
      return [{ isValid: false, platform: ALL }];
    }
  }

  return [{ isValid: true, platform: ALL }];
};

export const lomavisPostApprovalMultiStep = (lomavisCreator: any) => {
  const { approval_process } = lomavisCreator;

  if (
    approval_process &&
    approval_process?.step_mode === STEP_MODE_MULTI_STEP
  ) {
    if (
      approval_process?.approval_step_1_users?.length === 0 &&
      !approval_process?.approval_step_1_group
    ) {
      return [{ isValid: false, platform: ALL }];
    } else if (
      approval_process?.approval_step_2_users?.length === 0 &&
      !approval_process?.approval_step_2_group
    ) {
      return [{ isValid: false, platform: ALL }];
    }
  }

  return [{ isValid: true, platform: ALL }];
};

export const lomavisPostApprovalPublishWithSchedule = (lomavisCreator: any) => {
  // checks if the post has a publication date for each platform
  const {
    platformEnabled,
    postData,
    is_recurring_post,
    recurrence_as_str,
    approval_process
  } = lomavisCreator;

  if (
    approval_process &&
    approval_process?.target === TARGET_PUBLISH_WITH_SCHEDULE
  ) {
    const results = Object.keys(platformEnabled)
      .filter((platform) => platformEnabled[platform])
      .map((platform) => {
        const post = postData[platform];
        if (!post) return { isValid: true, platform };
        if (is_recurring_post) {
          const rruleObj = rrulestr(recurrence_as_str);
          if (!rruleObj) return { isValid: false, platform };
          if (!rruleObj?.options?.dtstart || !rruleObj?.options?.until)
            return { isValid: false, platform };
          // use rrule  lib to check if there is a publication date TODO
          return { isValid: true, platform };
        } else {
          // use Date to parse the date if it is a valid date
          if (!post.planned_publication_datetime)
            return { isValid: false, platform };
          const date = new Date(post.planned_publication_datetime);
          if (isNaN(date.getTime())) {
            return { isValid: false, platform };
          }
          // Check if the date is in the future
          if (date.getTime() <= Date.now()) {
            return { isValid: false, platform }; // Invalid if it's in the past or present
          }
        }
        return { isValid: true, platform };
      });

    return removeDuplicates(results);
  } else {
    return [{ isValid: true, platform: ALL }];
  }
};

export const lomavisPostApprovalSaveAsApproved = (lomavisCreator: any) => {
  // checks if the post has a publication date for each platform
  const {
    platformEnabled,
    postData,
    is_recurring_post,
    recurrence_as_str,
    approval_process
  } = lomavisCreator;

  if (
    approval_process &&
    approval_process?.target === TARGET_SAVE_AS_APPROVED_POST
  ) {
    const results = Object.keys(platformEnabled)
      .filter((platform) => platformEnabled[platform])
      .map((platform) => {
        const post = postData[platform];
        if (!post) return { isValid: true, platform };

        //Invalidate if it has a recurring option
        if (is_recurring_post) {
          return { isValid: false, platform };
        }

        //Invalidate if it has a planned publication date
        if (post.planned_publication_datetime) {
          return { isValid: false, platform };
        }

        return { isValid: true, platform };
      });

    return removeDuplicates(results);
  } else {
    return [{ isValid: true, platform: ALL }];
  }
};

export const validateProductLinks = (lomavisCreator: any) => {
  const { platformEnabled, postData, general_post_type } = lomavisCreator;
  const PRODUCT_URL_FIELDS = [
    'product_link1',
    'product_link2',
    'product_link3',
    'product_more_information_link',
    'product_url_link'
  ];

  if (general_post_type !== POST_TYPE_PRODUCT) {
    return [{ isValid: true, platform: ALL }];
  }

  console.log('enabled', platformEnabled);

  const results = Object.keys(platformEnabled || {})
    .filter((platform) => platformEnabled[platform])
    .map((platform) => {
      const post = postData[platform];
      if (!post) return { isValid: true, platform };

      const hasInvalidLink = PRODUCT_URL_FIELDS.some((field) => {
        const value = post[field];
        return value && value.trim() !== '' && !isStrictURL(value);
      });

      return { isValid: !hasInvalidLink, platform };
    });

  return removeDuplicates(results);
};
